import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit'> & {
  timezone: string;
};

type Response = any; // You might want to type this more specifically

const validate = (params: RequestParams) => {
  const { timezone } = params;
  if (!timezone) {
    throw new Error('Timezone is required');
  }
};

export const getLatestOrders = async (
  scope: RequestScope,
  params: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(params);

    const { limit = 10, timezone } = params;
    const url = `order?limit=${limit}&sort=created_at:-1&tz=${timezone}`;

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(url, options);

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
